import CellService from './CellService';

export default CellService;
